import { useRef, useEffect } from 'react';

import { NewsCardBody, NewsCardHeader } from '@/pages/NewsBriefing/_components/NewsCard';
import { NewsCharts } from '@/pages/NewsBriefing/_components/NewsCharts';
import { parseSummary } from '@/pages/NewsBriefing/_components/NewsCard';
import { NewsSellerPoints } from '@/pages/NewsBriefing/_components/NewsSeleerPoints';
import { NewsSources } from '@/pages/NewsBriefing/_components/NewsSources';
import type { EcommerceNewsItem } from '@/types/api';
import { LayoutCardContainer } from './Layouts';

export const NewsCard = ({ item, active }: { item: EcommerceNewsItem; active: boolean }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  // 카드가 활성화되었을 때 scrollTop = 0
  useEffect(() => {
    if (active && scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [active]);

  return (
    <LayoutCardContainer scrollRef={scrollRef}>
      <CardHeader />
      <div className="flex flex-col gap-[8px]">
        <NewsCardHeader title={item.title} isDashboard />
        <div className="flex flex-col gap-[16px]">
          <NewsBody item={item} active={active} />
          <SellerPoints item={item} />
        </div>
        <Sources item={item} />
      </div>
    </LayoutCardContainer>
  );
};

export const CardHeader = () => {
  return <h2 className="flex text-point-500 Body4S14">이커머스 소식</h2>;
};

const NewsBody = ({ item, active }: { item: EcommerceNewsItem; active: boolean }) => {
  // 차트 렌더링 조건을 변수로 저장
  const hasChart =
    Object.keys(item.keywordCount).length > 0 &&
    Object.values(item.keywordCount).some((arr) => Array.isArray(arr) && arr.length > 0);

  return (
    <div className="space-y-5">
      <NewsCardBody summary={parseSummary(item.summary)} />
      {hasChart && (
        <div>
          <NewsCharts keywordCount={item.keywordCount} active={active} isDashboard />
        </div>
      )}
    </div>
  );
};

const SellerPoints = ({ item }: { item: EcommerceNewsItem }) =>
  item.sellerPoints?.length ? <NewsSellerPoints sellerPoints={item.sellerPoints} /> : null;

const Sources = ({ item }: { item: EcommerceNewsItem }) =>
  item.sources?.length ? <NewsSources sources={item.sources} isDashboard /> : null;
